<template>
  <div class="report-table">
    <h2 v-if="type===1">Produkt in Zahlen</h2>

    <div v-if="type === 1" class="base">

      <h3>Stammdaten</h3>

      <div class="columns">
        <div v-for="column in template.table()"
             class="column">
          <div v-for="field in column"
               class="columns field">
            <div class="column"><strong>{{ field.title }}</strong></div>
            <div :is="'tablefield-' + field.type"
                 :config="getFieldConfig(field)"
                 :data="getFieldData(field.path)"
                 :product="data"
                 class="column"></div>
          </div>
        </div>
      </div>

    </div>

    <!--<div v-if="type === 2" class="figures">-->

    <!--<h3>Kennzahlen</h3>-->

    <!--<div class="columns">-->
    <!--<div class="column"-->
    <!--v-for="column in template.figures()">-->
    <!--<div class="columns field"-->
    <!--v-for="field in column">-->
    <!--<div class="column">{{field.title}}</div>-->
    <!--<div class="column"-->
    <!--:is="'tablefield-' + field.type"-->
    <!--:data="getFieldData(field.path)"-->
    <!--:config="getFieldConfig(field)"-->
    <!--:product="data"></div>-->
    <!--</div>-->
    <!--</div>-->
    <!--</div>-->

    <!--</div>-->

    <div v-if="type === 2" class="figures">

      <h3>Rückzahlungsprofil</h3>

      <div class="columns">
        <div v-for="column in template.payback()"
             class="column">
          <div v-for="field in column"
               class="columns field">
            <div class="column"><strong>{{ field.title }}</strong></div>
            <div :is="'tablefield-' + field.type"
                 :config="getFieldConfig(field)"
                 :data="getFieldData(field.path)"
                 :product="data"
                 class="column"></div>
          </div>
        </div>
      </div>

    </div>

  </div>

</template>

<script>
import FieldMixin from "../table-field/FieldMixin";

export default {
  name: 'product-table-report',
  mixins: [FieldMixin],
  props: {
    data: {
      type: Object,
      required: true
    },
    template: {
      type: Object,
      required: true
    },
    type: {
      type: Number,
      required: true
    }
  },
  methods: {
    getFieldData(path) {
      return this._.get(this.data, path)
    },
    getFieldConfig(field) {
      return this._.get(field, 'config', {})
    }
  }
}
</script>



// WEBPACK FOOTER //
// BlockProductTableReport.vue?df37dfae